import Vue from 'vue';
import Util from '@/helper/Utility.js';
import Locale from '@/helper/locale/locale.js';
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
import BzbsProfile from '@/core/Account/service/BzbsProfile.js';
import { ProfileModel, ProfileAddressModel, ProfileShippingAddressModel, AccountUserModel } from '@/core/Account/model/AccountModel.js';
import { Encrypt } from '@/core/Encrypt/Encrypt';
//Main key.
const KEY_COOKIE_USER = 'BzbsUser';
const KEY_COOKIE_PROFILE = 'BzbsProfile';
const KEY_COOKIE_PROFILE_ADDRESS = 'BzbsProfileAddress';
const KEY_COOKIE_PROFILE_SHIPPING_ADDRESS = 'BzbsProfileShippingAddress';
const KET_COOKIE_PROFILE_EXTENSION_JSON = 'BzbsProfileExtensionJson';

const KEY_COOKIE_USER_DETAIL = 'BzbsUserDetail';

/**
 * Token
 * @method getToken
 * @method getTokenShuffle
 * @method updateToken
 *
 * Cache
 * @method getCacheUser
 * @method setCacheUser
 * @method removeCacheUser
 * @method getCachePoint
 * @method getCachePointUpdateDate
 * @method updatePoint
 * @method getCacheCustom
 * @method setCacheCustom
 * @method removeCacheCustom
 *
 * Login
 * @method setLogin
 * @method setLogout
 * @method loginStatus
 * @method isLogin
 *
 * Api login
 * @method apiGetPoint
 * @method apiBzbsLogin
 * @method apiDeviceLogin
 * @method apiFBLogin
 * @method apiLogout
 *
 * Cache profile
 * @method getCacheProfile
 * @method setCacheProfile
 * @method removeCacheProfile
 * @method getCacheProfileAddress
 * @method setCacheProfileAddress
 * @method removeCacheProfileAddress
 * @method getCacheProfileShippingAddres
 * @method setCacheProfileShippingAddres
 * @method removeCacheProfileShippingAddres
 * @method setCacheAllProfile
 * @method removeCacheAllProfile
 *
 * Api profile
 * @method apiGetProfile
 * @method apiUpdateProfile
 * @method apiUpdateProfileLocale
 * @method apiUpdateProfileShippingAddress
 */
export default {
    initial: function () {
        Vue.initFinished = false;
        this.apiGetProfile().then(() => {
            Vue.initFinished = true;
        }).catch(() => {
            Vue.initFinished = true;
        });
    },
    //#region user
    /**
     * Get user token.
     * @return {string|null} user token.
     */
    // getToken: function () {
    //     return this.getCacheUser() ? this.getCacheUser().token : null;
    // },

    getToken() {
        let account = this.getCacheUser()
        if (!account) {
            return null;
        }
        return account.jwt
    },

    getTokenShuffle: function() {
        var token = this.getToken();
        return Util.shuffleToken(token);
    },

    /**
     * Update user token.
     * @param {Object} strToken
     * @return {object} user.
     */
    updateToken: function (strToken) {
        var objUser = this.getCacheUser();
        objUser.token = strToken;
        this.setCacheUser(objUser);

        return objUser;
    },

    /**
     * Get cache user.
     * @return {object} Cache user.
     */
    // getCacheUser: function () {
    //     return Vue.$cookies.get(KEY_COOKIE_USER);
    // },

    getCacheUser() {
        // let account = new AccountModel()
        let account = this.loadCache()
        // console.log('get cache user', account);
        return account
    },
    /**
     * Set cache user.
     * @param {object} objUser
     */
    setCacheUser: function (obj) {
        var objUser = new AccountUserModel(obj);
        this.removeCacheUser();
        Vue.$cookies.set(KEY_COOKIE_USER, JSON.stringify(objUser));
    },

    /**
     * Get cache user detail.
     * @return {object} objUserDetail
     */
    getCacheUserDetail: function () {
        return JSON.parse(localStorage.getItem(KEY_COOKIE_USER_DETAIL));
    },

    /**
     * Set cache user detail.
     * @param {object} objUserDetail
     */
    setCacheUserDetail: function (objUserDetail) {
        this.removeCacheUserDetail();
        localStorage.setItem(KEY_COOKIE_USER_DETAIL, JSON.stringify(objUserDetail));
    },

    /**
     * Remove cache user detail
     */
    removeCacheUserDetail: function () {
        localStorage.removeItem(KEY_COOKIE_USER_DETAIL);
    },

    /**
     * Get point.
     * @return {number} User point.
     */
    getCachePoint: function () {
        if (this.isLogin()) {
            var objUser = this.getCacheUser();
            if (objUser.updated_points != null &&
                objUser.updated_points.points != null) {
                return objUser.updated_points.points;
            }
        }

        return 0;
    },
    /**
     * Get point from profile.points array (first available point).
     * @return {number} Point balance.
     */
    getCachePointFromProfile: function () {
        if (this.isLogin()) {
            var objProfile = this.getCacheProfile();
            if (objProfile && objProfile.points && objProfile.points.length > 0) {
                // use first available point
                return objProfile.points[0].Balance || 0;
            }
        }
        // fallback to use point from updated_points
        return this.getCachePoint();
    },

    getCachePointUpdateDate: function () {
        if (this.isLogin()) {
            var objUser = this.getCacheUser();
            if (objUser.updated_points != null &&
                objUser.updated_points.points != null) {
                return objUser.updated_points.time;
            }
        }

        return 0;
    },
    /**
     * Remove cache user.
     */
    removeCacheUser: function () {
        Vue.$cookies.remove(KEY_COOKIE_USER);
    },

    /**
     * Set user login.
     * @param {object} objUser
     */
    setLogin: function (objUser) {
        this.setCacheUser(objUser);
        var localeCode = objUser.locale;
        Locale.setLocale(localeCode);
    },

    /**
     * Set user logout.
     * @return {promises} Logout response.
     */
    setLogout: function () {
        var token = this.gettoken();
        this.removeCacheUser();
        this.removeCacheAllProfile();

        return this.apiLogout(token);
    },

    /**
     * Update point.
     * @param {object} objUpdatePoints
     */
    updatePoint: function (objUpdatePoints) {
        var objUser = this.getCacheUser();
        var objProfile = this.getCacheProfile();
        objUser.updated_points = objUpdatePoints;
        objProfile.updated_points = objUpdatePoints;
        this.setCacheUser(objUser);
        this.setCacheProfile(objProfile);
    },


    /**
     * Check login wait for check token status.
     * @return Promise
     */
    loginStatus: function () {
        return new Promise((resolve) => {
            if (Vue.initFinished) {
                var strToken = this.getToken();
                var rs = !Util.isEmptyStr(strToken);
                resolve(rs);
            } else {
                var itv = setInterval(() => {
                    if (Vue.initFinished) {
                        var strToken = this.getToken();
                        var rs = !Util.isEmptyStr(strToken);
                        clearInterval(itv);
                        resolve(rs)
                    }
                }, 200);
            }
        });
    },

    /**
     * Check login.
     * @return {boolean} Login status.
     */
    isLogin: function() {
        var strToken = this.getToken();
        return !Util.isEmptyStr(strToken);
    },

    /**
     * Get user point.
     * @returns {promises} Update point object.
     */
    apiGetPoint: function () {
        return new Promise((resolve, reject) => {
            var strToken = this.getToken();
            BzbsProfile.getPoint(strToken)
                .then((response) => {
                    this.updatePoint(response.data);
                    resolve(response.data);
                }).catch((error) => {
                    reject(error);
                });
        });
    },

    /**
     * Bzbs login.
     * @param {string} strUsername
     * @param {string} strPassword
     * @return {object} Return user and profile.
     */
    apiBzbsLogin: function (strUsername, strPassword) {
        return new Promise((resolve, reject) => {
            BzbsAuth.apiLogin(strUsername, strPassword, null, null, null, false).then((response) => {
                //Set User to cache.
                this.setLogin(response.data);
                //Get Profile to cache.
                this.apiGetProfile().then((objProfile) => {
                    //Return User Data from api.
                    var objResult = {
                        "user": response.data,
                        "profile": objProfile
                    };
                    resolve(objResult);
                }).catch((error) => {
                    reject(error);
                });

            }).catch((error) => {
                reject(error);
            });
        });
    },

    apiDeviceLogin: function () {

    },

    apiFBLogin: function () {

    },

    /**
     * Logout.
     */
    apiLogout: function (strToken) {
        return new Promise((resolve, reject) => {
            if (!strToken) {
                resolve(null);
            } else {
                BzbsAuth.apiLogout(strToken, null, null).then((response) => {
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
            }
        });
    },
    //#endregion user

    //#region profile
    /**
     * Get cache profile.
     * @return {object|null} Profile.
     */
    getCacheProfile: function () {
        return Vue.$cookies.get(KEY_COOKIE_PROFILE);
    },

    /**
     * Set cache profile.
     * @param {object|null} objProfile
     */
    setCacheProfile: function (objProfile) {
        this.removeCacheProfile();
        Vue.$cookies.set(KEY_COOKIE_PROFILE, JSON.stringify(objProfile));
    },

    /**
     * Remove cache profile.
     */
    removeCacheProfile: function () {
        Vue.$cookies.remove(KEY_COOKIE_PROFILE);
    },

    /**
     * Get cache profile address.
     * @return {object|null}
     */
    getCacheProfileAddress: function () {
        return Vue.$cookies.get(KEY_COOKIE_PROFILE_ADDRESS);
    },

    /**
     * Set cache profile address.
     * @param {object|null} objProfileAddress
     */
    setCacheProfileAddress: function (objProfileAddress) {
        this.removeCacheProfileAddress();
        Vue.$cookies.set(KEY_COOKIE_PROFILE_ADDRESS, JSON.stringify(objProfileAddress));
    },

    /**
     * Remove cache profile address.
     */
    removeCacheProfileAddress: function () {
        Vue.$cookies.remove(KEY_COOKIE_PROFILE_ADDRESS);
    },

    /**
     * Get cache profile shipping address.
     * @return {object|null} Profile shipping address
     */
    getCacheProfileShippingAddres: function () {
        return Vue.$cookies.get(KEY_COOKIE_PROFILE_SHIPPING_ADDRESS);
    },

    /**
     * Set cache profile shipping address.
     * @param {object|null} objProfileShippingAddress
     */
    setCacheProfileShippingAddres: function (objProfileShippingAddress) {
        this.removeCacheProfileShippingAddres();
        Vue.$cookies.set(KEY_COOKIE_PROFILE_SHIPPING_ADDRESS, JSON.stringify(objProfileShippingAddress));
    },
    /**
     * Remove cache profile shipping address.
     */
    removeCacheProfileShippingAddres: function () {
        Vue.$cookies.remove(KEY_COOKIE_PROFILE_SHIPPING_ADDRESS);
    },

    /**
     * Get cache profile extension json.
     * @return {object|null} Profile extension json
     */
    getCacheProfileExtensionJson: function () {
        return JSON.parse(localStorage.getItem(KET_COOKIE_PROFILE_EXTENSION_JSON));
    },

    /**
     * Set cache profile extension json.
     * @param {object|null} objProfileExtensionJson
     */
    setCacheProfileExtensionJson: function (objProfileExtensionJson) {
        this.removeCacheProfileShippingAddres();
        localStorage.setItem(KET_COOKIE_PROFILE_EXTENSION_JSON, JSON.stringify(objProfileExtensionJson));
    },
    /**
     * Remove cache profile extension json.
     */
    removeCacheProfileExtensionJson: function () {
        localStorage.removeItem(KET_COOKIE_PROFILE_EXTENSION_JSON);
    },

    /**
     * Set cache for profile, profile address, profile shipping address.
     * @param {object|null} objProfile
     * @param {object|null} objProfileAddress
     * @param {object|null} objProfileShippingAddress
     */
    setCacheAllProfile: function (objProfile, objProfileAddress, objProfileShippingAddress) {
        this.removeCacheAllProfile();
        this.setCacheProfile(objProfile);
        this.setCacheProfileAddress(objProfileAddress);
        this.setCacheProfileShippingAddres(objProfileShippingAddress);
        // this.setCacheProfileExtensionJson(objProfileExtensionJson);
    },

    /**
     * Remove all profile cache.
     */
    removeCacheAllProfile: function () {
        this.removeCacheProfile();
        this.removeCacheProfileAddress();
        this.removeCacheProfileShippingAddres();
        this.removeCacheProfileExtensionJson();
    },

    /**
     * Get profile.
     * @return {object|null} Profile.
     */
    apiGetProfile: function () {
        return new Promise((resolve, reject) => {
            var strToken = this.getToken();
            if (!strToken) {
                resolve(null);
            } else {
                BzbsProfile.getProfileAia(strToken).then((response) => {
                    let res = response.data
                    var objProfile = new ProfileModel(res);
                    var objProfileAddress = new ProfileAddressModel(res);
                    var objProfileShippingAddress = new ProfileShippingAddressModel(res);
                    // var objProfileExtensionJson = response.data.ExtensionJsonProperty;
                    console.log('apiGetProfile objProfile', objProfile);
                    var objProfileExtensionJson = res;
                    this.setCacheUserDetail(objProfileExtensionJson);
                    this.setCacheAllProfile(objProfile, objProfileAddress, objProfileShippingAddress);
                    resolve(objProfile);
                }).catch((error) => {
                    if (error.response && error.response.data && error.response.data.error) {
                        if (error.response.data.error.code == 412) {
                            this.removeCacheUser();
                            this.removeCacheAllProfile();
                            location.reload();
                            console.log('error token');
                        }
                    }

                    reject(error);
                });
            }
        });
    },

    /**
     * Update user profile.
     * @param {object} objProfile
     * @param {object} objProfileAddress
     * @param {string} strExtendJson
     */
    apiUpdateProfile: function (objProfile, objProfileAddress, strExtendJson) {
        return new Promise((resolve, reject) => {
            var strToken = this.getToken();
            if (!strToken) {
                resolve(null);
            } else {
                BzbsProfile.updateProfile(strToken, objProfile, objProfileAddress, strExtendJson).then((response) => {
                    //Update cache profile.
                    var objNewProfile = new ProfileModel(response.data);
                    var objNewProfileAddress = new ProfileAddressModel(response.data);
                    var objNewProfileShippingAddress = new ProfileShippingAddressModel(response.data);
                    this.setCacheAllProfile(objNewProfile, objNewProfileAddress, objNewProfileShippingAddress);
                    //Update cache user.
                    var objUser = this.getCacheUser();
                    objUser.token = response.data.Token;
                    objUser.updated_points = objNewProfile.updated_points;
                    this.setCacheUser(objUser);

                    var objResult = {
                        "objUser": objUser,
                        "objProfile": objProfile
                    };
                    resolve(objResult);
                }).catch((error) => {
                    reject(error);
                });
            }
        });
    },

    /**
     * Update user locale.
     * @param {number} localeCode
     */
    apiUpdateProfileLocale: function (localeCode) {
        var objProfile = this.getCacheProfile();
        if (objProfile)
            objProfile.strLocale = localeCode;

        var objProfileAddress = this.getCacheProfileAddress();

        return this.apiUpdateProfile(objProfile, objProfileAddress);
    },

    /**
     * Update user shipping address.
     * @param {object} objProfileShippingAddress AddressModel /Model/AddressModel.js
     */
    apiUpdateProfileShippingAddress: function (objProfileShippingAddress) {
        return new Promise((resolve, reject) => {
            var strToken = this.getToken();
            if (!strToken) {
                resolve(null);
            } else {
                BzbsProfile.updateShippingAddress(strToken, objProfileShippingAddress)
                    .then((objResult) => {
                        var objNewProfileShippingAddress = new ProfileShippingAddressModel(objResult);
                        this.setCacheProfileShippingAddres(objNewProfileShippingAddress);
                        resolve(objNewProfileShippingAddress);
                    }).catch((error) => {
                        reject(error);
                    });
            }
        });
    },
    //#endregion profile

    //#region general function
    /**
     * Get cache json by key.
     * @param {string} strCookieKey
     * @return {object|null} Profile extend json.
     */
    getCacheCustom: function (strCookieKey) {
        return Vue.$cookies.get(strCookieKey);
    },

    /**
     * Set cache json by key.
     * @param {string} strCookieKey
     * @param {object|null} objData
     */
    setCacheCustom: function (strCookieKey, objData) {
        this.removeCacheCustom(strCookieKey);
        Vue.$cookies.set(strCookieKey, JSON.stringify(objData));
    },

    /**
     * Remove cache extend json.
     * @param {string} strCookieKey
     */
    removeCacheCustom: function (strCookieKey) {
        Vue.$cookies.remove(strCookieKey);
    },

    //#region cache local
    /**
     * Set cache to local storage.
     * @param {string} key
     * @param {any} data
     */
    setCache: function (key, data) {
        window.localStorage.setItem(key, data);
    },

    /**
     * Get cache from local storage.
     * @param {string} key
     * @return {any} Cached data
     */
    getCache: function (key) {
        return window.localStorage.getItem(key);
    },

    /**
     * Remove cache from local storage.
     * @param {string} key
     */
    removeCache: function (key) {
        window.localStorage.removeItem(key);
    },

    /**
     * Save cache with encryption.
     * @param {object} info
     */
    saveCache: function (info) {
        var data = this.encryptAccount(info);
        this.setCache(KEY_COOKIE_USER, data);
    },
    loadCache() {
        // let cache = new CacheHelper(ConfigManager.getCacheType());
        let encryptData = this.getCache(KEY_COOKIE_USER);

        if (encryptData == null) {
            return null;
        }
        let data = this.decryptAccount(encryptData);
        if(data == null) return null

        // this.jwt = data.jwt;
        // this.userId = data.userId;
        // this.userLevel = data.userLevel;
        // this.userLevelDetail = data.userLevelDetail;
        // this.uuid = data.uuid;
        // this.appId = data.appId;
        // this.canRedeem = data.canRedeem;
        // this.loginChanel = data.loginChanel;
        // this.isFbUser = data.isFbUser;
        // this.joinDate = data.joinDate;
        // this.locale = data.locale;
        // this.platform = data.platform;
        // this.line = data.line;
        // this.point = data.point;
        // this.pdpa = data.pdpa;

        return data;
    },

    /**
     * Encrypt account information.
     * @param {object} account Account object to encrypt
     * @return {string} Encrypted string
     */
    encryptAccount: function (account) {
        var info = Util.normalObject(account);
        console.log('normal object account', info);

        var encrypter = new Encrypt();
        var json = JSON.stringify(info);
        var encryptedData = encrypter.encrypt(json);

        return encryptedData;
    },

    /**
     * Decrypt account information.
     * @param {string} encryptData Encrypted string
     * @return {object} Decrypted account info
     */
    decryptAccount: function (encryptData) {
        if (!encryptData) {
            return null;
        }

        try {
            var encrypter = new Encrypt();
            var infoStr = encrypter.decrypt(encryptData);
            if (!infoStr) {
                return null;
            }
            var infoJson = JSON.parse(infoStr);
            return infoJson;
        } catch (e) {
            console.error('Decrypt account error:', e);
            return null;
        }
    }
    //#endregion cache local
}
